import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../../environment/BackendService";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";

const useGpiScreen = (
  setScreenType,
  selectParams,
  hideModal,
  lookupType,
  selectMode,
  onSelect,
  selectParamsData = {
    gpiId: "",
    gpiName: "",
  },
  screen_title,
  screenNumber,
  multiSelect = false
) => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const [paramsData, setParamsData] = useState(selectParamsData);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isFrescheJump, setIsFrescheJump] = useState(false);
  const toast = useToast();
  const location = useLocation();
  const { ADD_GPI, DISPLAY_GPI, GPI_PRODUCT_ID } = ROUTE_PATHS;

  const formFields = [
    {
      fieldLabel: "GPI ID",
      name: "gpiId",
      label: "GPI",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 14,
    },
    {
      fieldLabel: "GPI Name",
      name: "gpiName",
      label: "GPI Name",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 60,
    },
  ];

  const dropdownOptions = [];

  const ctaButtons = [
    {
      button_label: "Search By Product ID / Label Name",
      button_handeler: () => {
        //navigateToPage(GPI_PRODUCT_ID);
        setScreenType("productId");
      },
      button_key: "F17",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const handleBack = useCallback(() => {
    if (lookupType === "external") {
      const message = {
        type: "hideModal",
      };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  }, [hideModal, lookupType]);

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: handleBack,
      button_key: "F12",
    },
  ];

  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        /*navigateToPage(ADD_GPI, {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData[parmKey]],
          previousScreen: location.pathname,
        });*/
        const selectedRecords = selectedRows.length ? selectedRows : [rowData];
        const selectedData = selectedRecords.map((row) => {
          const data = selectParams.reduce((acc, key) => {
            if (row.hasOwnProperty(key["target"])) {
              acc[key["source"]] = row[key["target"]];
            }
            return acc;
          }, {});
          return data;
        });

        if (lookupType !== "external") {
          onSelect(multiSelect ? selectedData : selectedData[0]);
        } else {
          const message = {
            type: "responseData",
            data: multiSelect ? selectedData : selectedData[0],
            multiSelect: multiSelect,
          };
          window.parent.postMessage(message, "*");
        }
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        /* navigateToPage(DISPLAY_GPI, {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData[parmKey]],
          previousScreen: location.pathname,
        });*/
        if (lookupType === "external" && isFrescheJump) {
          const message = {
            type: "navigateData",
            data: { ...rowData },
            target: "RCPID009",
          };
          console.log("display message", message);
          return window.parent?.postMessage(message, "*");
        }
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPID009",
          parameters: {
            gpiIdNumber: rowData["gpiId"],
            // gp3GpiMscListDesc: rowData["gpiName"],
          },
        };
        window.top?.postMessage(message, "*");
      },
    },
  ];

  const columnDef = [
    {
      header: "GPI",
      field: "gpiId",
    },
    {
      header: "GPI Name",
      field: "gpiName",
    },
  ];

  const parmKey = "gpiId";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcgpip`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteGpi = () => {
    if (selectedOption === "yes") {
      const params = { gpiIdNumber: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/gpi", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    let params = {
      gpiId: paramsData?.gpiId || "",
      gpiName: paramsData?.gpiName || "",
    };
    const queryParams = new URLSearchParams({ ...params, screenNumber });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcgpip/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setParamsData(paramData?.paramsData);
      setIsFrescheJump(paramData?.isFrescheJump || false);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });
  
  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteGpi,
    setSelectedOption,
    leftButtons,
  };
};

export default useGpiScreen;
